import React from 'react';
import { Box, Card, CardContent, Divider, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

function WidgetShell({ icon, title, subtitle, action, children, cardSx }) {
  return (
    <Card
      sx={{
        border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.14)}`,
        boxShadow: (theme) => `0 4px 20px ${alpha(theme.palette.primary.main, 0.07)}`,
        borderRadius: 3,
        height: '100%',
        ...cardSx,
      }}
    >
      <CardContent>
        <Stack
          direction="row"
          alignItems={subtitle ? 'flex-start' : 'center'}
          justifyContent="space-between"
          sx={{ mb: 1.2 }}
        >
          <Stack direction="row" alignItems="center" spacing={0.75}>
            {icon}
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 700, fontSize: 15, lineHeight: 1.2 }}>
                {title}
              </Typography>
              {subtitle && (
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.4 }}>
                  {subtitle}
                </Typography>
              )}
            </Box>
          </Stack>
          {action && <Box sx={{ flexShrink: 0, ml: 1 }}>{action}</Box>}
        </Stack>
        <Divider sx={{ mb: 1.5 }} />
        {children}
      </CardContent>
    </Card>
  );
}

export default WidgetShell;
